import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type OverduePaymentBannerFragment = (
  { __typename: 'Member' }
  & Pick<Types.Member, 'id' | 'idPremOrgsAdmin'>
  & { organizations: Array<(
    { __typename: 'Organization' }
    & Pick<
      Types.Organization,
      | 'id'
      | 'displayName'
      | 'name'
      | 'offering'
    >
    & { paidAccount?: Types.Maybe<(
      { __typename: 'PaidAccount' }
      & Pick<
        Types.PaidAccount,
        | 'billingDates'
        | 'needsCreditCardUpdate'
        | 'products'
        | 'standing'
      >
    )> }
  )> }
);

export const OverduePaymentBannerFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OverduePaymentBanner' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Member' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idPremOrgsAdmin' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'offering' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paidAccount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'billingDates' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'needsCreditCardUpdate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'products' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'standing' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseOverduePaymentBannerFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      OverduePaymentBannerFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseOverduePaymentBannerFragmentResult
  extends Omit<Apollo.UseFragmentResult<OverduePaymentBannerFragment>, 'data'> {
  data?: OverduePaymentBannerFragment;
}

export const useOverduePaymentBannerFragment = ({
  from,
  returnPartialData,
  ...options
}: UseOverduePaymentBannerFragmentOptions): UseOverduePaymentBannerFragmentResult => {
  const result = Apollo.useFragment<OverduePaymentBannerFragment>({
    ...options,
    fragment: OverduePaymentBannerFragmentDoc,
    fragmentName: 'OverduePaymentBanner',
    from: {
      __typename: 'Member',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as OverduePaymentBannerFragment };
};
